import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import GroupIcon from "@mui/icons-material/GroupOutlined";
import PersonIcon from "@mui/icons-material/PersonOutlined";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import LanIcon from "@mui/icons-material/LanOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import ExploreIcon from "@mui/icons-material/ExploreOutlined";
import BadgeIcon from "@mui/icons-material/BadgeOutlined";
import Co2Icon from "@mui/icons-material/Co2";
import MapIcon from "@mui/icons-material/MapOutlined";
import DashboardIcon from "@mui/icons-material/DashboardOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import BorderAllIcon from "@mui/icons-material/BorderAll";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import DataThresholdingIcon from "@mui/icons-material/DataThresholdingOutlined";
import DownloadIcon from "@mui/icons-material/DownloadOutlined";
import HistoryIcon from "@mui/icons-material/History";
import AssignmentIcon from "@mui/icons-material/AssignmentOutlined";
import MailIcon from "@mui/icons-material/MailOutlined";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import SpeedIcon from "@mui/icons-material/Speed";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import { AnalyticsIcon } from "./sideBarIcon";
import AlbumIcon from "@mui/icons-material/AlbumOutlined";
import TroubleshootIcon from "@mui/icons-material/Troubleshoot";
import SummarizeIcon from '@mui/icons-material/SummarizeOutlined';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import AcUnitIcon from '@mui/icons-material/AcUnitOutlined';
import RuleIcon from '@mui/icons-material/Rule';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import TopicIcon from '@mui/icons-material/Topic';
import DataArrayIcon from '@mui/icons-material/DataArray';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
// eslint-disable-next-line import/no-anonymous-default-export
type MenuType = {
  label: string;
  icon: JSX.Element;
  iconClosed?: JSX.Element;
  iconOpened?: JSX.Element;
  to?: string;
  menuId: string;
  subMenu?: MenuType[]
}
const MenuItems: MenuType[] = [
  {
    label: "Dashboard",
    icon: <DashboardIcon />,
    to: "/dashboard",
    menuId: "13",
  },
  // {
  //   label: "Dashboard",
  //   icon: <SpeedIcon />,
  //   to: "/dashboard",
  //   menuId: "40",
  // },
  {
    label: "Facilities",
    icon: <DashboardCustomizeIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    menuId: "38",
    subMenu: [
      {
        label: "Main View",
        icon: <SpeedIcon />,
        to: "/facility/dashboard",
        menuId: "29",
      },
      {
        label: "Detection",
        icon: <GraphicEqIcon />,
        to: "/element-detection",
        menuId: "39",
      },
    ],
  },
  {
    label: "Query",
    icon: <HelpOutlineIcon />,
    to: "/query",
    menuId: "16",
  },
  {
    label: "Analytics",
    icon: <AnalyticsIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    menuId: "11",
    subMenu: [
      {
        label: "Time Series",
        icon: <AnalyticsIcon />,
        to: "/analytics/timeseriesdetail",
        menuId: "33",
      },
      {
        label: "Characteristics History",
        icon: <HistoryIcon />,
        to: "/substanceHistory",
        menuId: "25",
      },
      {
        label: "Core",
        icon: <AlbumIcon />,
        to: "/analytics/core",
        menuId: "31",
      },
      {
        label: "Root",
        icon: <TroubleshootIcon />,
        to: "/analytics/root",
        menuId: "32",
      },
    ],
  },

  // {
  //   label: "Analytics Dashboard",
  //   icon: <DashboardCustomizeIcon />,
  //   iconClosed: <ExpandMoreIcon />,
  //   iconOpened: <ChevronRightIcon />,
  //   to: "/devicemanagement",
  //   menuId: "28",
  //   subMenu: [
  //     {
  //       label: "Threshold Summary",
  //       icon: <HistoryIcon />,
  //       to: "/thresholdsummary",
  //       menuId: "30",
  //     },
  //   ],
  // },
  // {
  //   label: "Overview",
  //   icon: <VisibilityOutlinedIcon />,
  //   to: "/overview",
  //   menuId: "14",
  // },
  {
    label: "Export History",
    icon: <SaveAltIcon />,
    to: "/export/history",
    menuId: "",
  },
  {
    label: "Admin Dashboard",
    icon: <AdminPanelSettingsIcon />,
    to: "/ops-dashboard",
    menuId: "19",
  },
  {
    label: "Tile Management",
    icon: <BorderAllIcon />,
    to: "/tilemanagement",
    menuId: "17",
  },  
  {
    label: "Category Management",
    icon: <ViewKanbanIcon />,
    to: "/category",
    menuId: "44",
  },
  {
    label: "Threshold Management",
    icon: <DataThresholdingIcon />,
    to: "/threshold",
    menuId: "20",
  },
  {
    label: "Download Dashboard",
    icon: <DownloadIcon />,
    to: "/downloaddashboard",
    menuId: "22",
  },
  {
    label: "User Management",
    icon: <PersonIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    to: "/usermanagement",
    menuId: "18",
    subMenu: [
      {
        label: "Roles",
        icon: <BadgeIcon />,
        to: "/roleManagement",
        menuId: "3",
      },
      {
        label: "Admin List",
        icon: <PersonIcon />,
        to: "/adminList",
        menuId: "12",
      },
      {
        label: "User List",
        icon: <GroupIcon />,
        to: "/userList",
        menuId: "2",
      },
    ],
  },
  {
    label: "Tenants",
    icon: <FormatListNumberedIcon />,
    to: "/tenantList",
    menuId: "1",
  },
  {
    label: "Tenant Report",
    icon: <SummarizeIcon />,
    to: "/tenantreport",
    menuId: "35",
  },
  {
    label: "Location",
    icon: <ExploreIcon />,
    to: "/location",
    menuId: "6",
  },
  {
    label: "Templates",
    icon: <AssignmentIcon />,
    to: "/templates",
    menuId: "26",
  },
  {
    label: "Third-Party Devices",
    icon: <PersonIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    to: "/thirdpartydevices",
    menuId: "24",
    subMenu: [
      {
        label: "Provider Integration",
        icon: <IntegrationInstructionsOutlinedIcon />,
        to: "/deviceIntegration",
        menuId: "34",
      },
    ]
  },
  {
    label: "Device Management",
    icon: <PersonIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    to: "/devicemanagement",
    menuId: "24",
    subMenu: [
      {
        label: "Device List",
        icon: <DevicesOtherIcon />,
        to: "/devices",
        menuId: "4",
      },
      {
        label: "Device Version",
        icon: <AcUnitIcon />,
        to: "/deviceversion",
        menuId: "36",
      },
      {
        label: "Assign Devices",
        icon: <GroupIcon />,
        to: "/internalIds",
        menuId: "21",
      },
      {
        label: "Device Configuration",
        icon: <LanIcon />,
        to: "/deviceConfig",
        menuId: "5",
      },
      {
        label: "Device History",
        icon: <SettingsBackupRestoreIcon />,
        to: "/deviceHistorty",
        menuId: "30",
      },

    ],
  },
  {
    label: "Calibration",
    icon: <Co2Icon />,
    to: "/detection",
    menuId: "7",
  },
  // {
  //   label: "Groups & Substance",
  //   icon: <ScienceIcon />,
  //   to: "/groupsSubstance",
  //   menuId: "8",
  // },
  {
    label: "Event Map",
    icon: <MapIcon />,
    to: "/eventMap",
    menuId: "10",
  },
  {
    label: "Send Emails",
    icon: <MailIcon />,
    to: "/sendemail",
    menuId: "27",
  },
  {
    label: "Notifications Rules",
    icon: <RuleIcon />,
    to: "/notification-rules",
    menuId: "37",
  },
  {
    label: "Generate Notification",
    icon: <ManageHistoryIcon />,
    to: "/generate-notification",
    menuId: "35",
  },
  {
    label: "IEQGpt Configuration",
    icon: <QuestionAnswerIcon />,
    iconClosed: <ExpandMoreIcon />,
    iconOpened: <ChevronRightIcon />,
    to: "/ieq-gpt",
    menuId: "41",
    subMenu: [
      {
        label: "Topics",
        icon: <TopicIcon />,
        to: "/ieq-gpt/topics",
        menuId: "42",
      },
      {
        label: "Content",
        icon: <DataArrayIcon />,
        to: "/ieq-gpt/contents",
        menuId: "43",
      },
    ],
  },
];
export default MenuItems;

export const findMenuNameFromUrl = (url: string, menuItems: MenuType[] = MenuItems,): string => {
  for (const menu of menuItems) {
    if (menu.to === url) return menu.label;
    if (menu?.subMenu?.length) {
      const name: string | undefined = findMenuNameFromUrl(url, menu.subMenu);
      if (name) return name;
    }
  }
  return "";
}